<div class="timezone-selector" (click)="$event.stopPropagation()">
  <button class="trigger" type="button" (click)="toggleOpen()">
    <div class="label">
      <span class="selected" *ngIf="value; else placeholderTpl">{{ value }}</span>
      <ng-template #placeholderTpl>
        <span class="placeholder">{{ placeholder }}</span>
      </ng-template>
    </div>
    <span class="chevron" aria-hidden="true"></span>
  </button>

  <div class="panel" *ngIf="open">
    <ul class="list">
      <li class="item" *ngFor="let option of options" (click)="selectOption(option)" [class.active]="value === option">
        {{ option }}
      </li>
    </ul>
  </div>
</div>
